// extracted by mini-css-extract-plugin
export default {"animated_image":"productP4200R_animated_image__KdH5T","myAnimation":"productP4200R_myAnimation__74n5l","container":"productP4200R_container__s42GQ"};